import {
	getAgree,
	login as _login,
	logout,
	setAgree,
	adminGetConfig,
	adminSetConfig,
	getEntryFilters,
	getEntries,
	addEntry,
	putEntry, deleteEntry, adminGetUsers, adminSetCard, putEntries
} from './api';

const hasRole = (user, role) => {
	if (!user || !('roles' in user)) {
		return false;
	}
	if (user.roles.indexOf('root') !== -1) {
		return true;
	}
	if (user.roles.indexOf(role) !== -1) {
		return true;
	}
	return false;
};

export default store => ({
	login: (state, user, agree) => {
		store.setState({
			user,
			agree: agree.agree,
			isAdmin: hasRole(user, 'bhp_admin')
		});
	},
	logout: () => {
		store.setState({
			user: null,
			agree: false
		});
		sessionStorage.clear();
	},
	setAgree: async (state) => {
		const agree = await setAgree();
		store.setState({
			agree: agree.agree
		});
	},
	setSettings: async (state, settings) => {
		// if (!store.getState().isAdmin) {
		// 	return null;
		// }
		settings = await adminSetConfig(settings);
		if (!settings) {
			return;
		}
		store.setState({
			settings
		});
		return settings;
	},
	getSettings: async (state) => {
		// if (!store.getState().isAdmin) {
		// 	return null;
		// }
		if (store.getState().settings) {
			return store.getState().settings;
		}
		const settings = await adminGetConfig();
		store.setState({
			settings
		});
		return settings;
	},
	getFilters: async (state) => {
		// if (store.getState().filters) {
		// 	return store.getState().filters;
		// }
		const filters = await getEntryFilters();
		store.setState({
			filters
		});
		return filters;
	},
	getEntries: async (state, filters) => {
		store.setState({
			entries: await getEntries(filters)
		});
	},
	addEntry: async (state, entry) => {
		console.warn(entry);
		const newEntry = await addEntry(entry);
		if (!newEntry) {
			return;
		}
		const entries = [...store.getState().entries];
		entries.unshift(newEntry);
		store.setState({
			entries
		});
	},
	updateEntries: async (state, entries) => {
		await putEntries(JSON.stringify(entries));
		store.setState({
			entries: await getEntries()
		});
	},
	updateEntry: async (state, entry) => {
		const newEntry = await putEntry(entry);
		if (newEntry === false) {
			return;
		}
		store.setState({
			entries: newEntry ? state.entries.map(item => {
				if (item.nr_rek === newEntry.nr_rek) {
					item = { ...item, ...newEntry };
				}
				return item;
			}) : state.entries.filter(item => item.nr_rek !== entry.nr_rek)
		});
		return store.getState().entries;
	},
	removeEntry: async (state, entry) => {
		await deleteEntry(entry);
		store.setState({
			entries: state.entries.filter(item => item.nr_rek !== entry.nr_rek)
		});
	},
	adminGetUsers: async (state) => {
		if (!store.getState().isAdmin) {
			return null;
		}
		if (store.getState().cardUsers) {
			return store.getState().cardUsers;
		}
		const cardUsers = await adminGetUsers();
		store.setState({
			cardUsers
		});
	},
	adminSetCard: async (state, user) => {
		if (!store.getState().isAdmin) {
			return null;
		}
		await adminSetCard(user);
		store.setState({
			cardUsers: store.getState().cardUsers.map(u => {
				if (u.nr === user.pracownik_id) {
					console.error('eee');
					u.nr_karty = user.nr_karty;
				}
				return u;
			})
		});
	}
});



// WEBPACK FOOTER //
// ./actions.js